// extracted by mini-css-extract-plugin
export default {"container":"Formulario_container__nKrIW","input":"Formulario_input__DbAbv","button":"Formulario_button__0ugur"};